module.exports = __webpack_public_path__ + "img/prop-music-right.35417628.png";